import { createElement } from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import withStyles, { WithStyles } from 'react-jss';
import { ComponentDesc } from '../../store';
import { settingsPanelStyles as styles } from './styles';
import ReactTooltip from 'react-tooltip';

interface IProps extends WithStyles<typeof styles> {
    descriptor: ComponentDesc<any>;
}

const left_align = require('../icons/left_align.svg');
const center_align = require('../icons/center_align.svg');
const right_align = require('../icons/right_align.svg');

class TextAlign extends Component<IProps, any> {
    state = {
        active: true,
    };
    render() {
        let { descriptor } = this.props;

        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <div
                    style={{
                        display: 'flex',
                        paddingBottom: 10,
                        justifyContent: 'space-around',
                        alignItems: 'center',
                    }}>
                    <span className={classes.header} style={{ width: 121 }}>
                        Alignment
                    </span>

                    <button data-for="Left" title="Left Align" name="Left" value="left" className={descriptor.style.textAlign === 'left' ? classes.selectedItem : classes.align_button} onClick={(e) => (descriptor.style.textAlign = 'left')}>
                        <img src={left_align} />
                    </button>
                    <button data-for="Center" title="Center Align" name="Center" value="center" className={descriptor.style.textAlign === 'center' ? classes.selectedItem : classes.align_button} onClick={(e) => (descriptor.style.textAlign = 'center')}>
                        <img src={center_align} />
                    </button>
                    <button data-for="Right" title="Right Align" name="Right" value="right" className={descriptor.style.textAlign === 'right' ? classes.selectedItem : classes.align_button} onClick={(e) => (descriptor.style.textAlign = 'right')}>
                        <img src={right_align} />
                    </button>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(observer(TextAlign));
